import { render, staticRenderFns } from "./SmsConfirmation.vue?vue&type=template&id=0fc258ea&scoped=true"
import script from "./SmsConfirmation.vue?vue&type=script&lang=js"
export * from "./SmsConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SmsConfirmation.vue?vue&type=style&index=0&id=0fc258ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc258ea",
  null
  
)

export default component.exports